<template>
  <b-container fluid>
    <b-row class="dropzone__title mb-3 mt-3 mt-sm-0">
      <label class="text-center text-sm-left w-100 mb-0">
        {{ title }}
      </label>
    </b-row>
    <b-row
      class="dropzone__view"
      @dragover.prevent="dragHandler(true)"
      @dragenter.prevent="dragHandler(true)"
      @dragleave.prevent="dragHandler(false)"
      @drop.prevent="fileSelect($event.dataTransfer.files)"
    >
      <b-col
        cols="12"
        align-self="end"
        class="text-center"
      >
        <label>
          {{ $t('actions.drag-file') }}
        </label>
      </b-col>
      <b-col
        cols="12"
        class="text-center mt-3"
      >
        <b-btn
          size="sm"
          class="dropzone__button"
          variant="outline-primary"
          @click="openFileSelector"
        >
          {{ $t('actions.select-file') }}
          <input
            :multiple="isMultipleUpload"
            @change="fileSelect($event.target.files)"
            :accept="inputAccept.join(',')"
            class="dropzone__hidden-input"
            type="file"
            ref="fileInput"
          />
        </b-btn>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Dropzone',
  props: {
    inputAccept: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
    },
    isMultipleUpload: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: () => ({
    drag: false,
  }),
  methods: {
    dragHandler(value) {
      this.drag = value;
    },
    openFileSelector() {
      this.$refs.fileInput.click();
    },
    fileSelect(fileList) {
      const fileListArray = [...fileList];

      if (!fileList || !fileList.length > 0) {
        return;
      }

      this.$refs.fileInput.value = '';

      this.$emit('input', fileListArray);
    },
  },
};
</script>

<style lang="sass" scoped>
  @import src/styles/defaults/variables

  .dropzone
    &__hidden-input
      display: none
    &__title
      font-size: 1.2em
    &__button
      font-size: .9em
      font-weight: bold
    &__view
      border-radius: 5px
      padding: 15px
      min-height: 200px
      border: 2px dashed $color-gray-intermediary
      font-size: 1.2em
      color: $color-gray-intermediary
</style>
